// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2KbAo","content":"styles_content__3Wbuk","checkbox":"styles_checkbox__Mvy27","checkboxLabel":"styles_checkboxLabel__DAF2t"};